import * as React from "react";
import { forwardRef, memo } from "react";
const SvgOutlinedRightIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: "1rem", height: "1rem", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6 14L10.6667 8.16667L6 2.33333", stroke: "#147752", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgOutlinedRightIcon);
const Memo = memo(ForwardRef);
export default Memo;
